<template>
    <div id="WeSayHello">
        <h1>We say Hello!</h1>
        <p class="martin">{{martin}}</p>
        <p class="joakim">{{joakim}}</p>
        <p class="sondre">{{Sondre}}</p>

        <br />

        <click-component />
        <todo-app />
  </div>
</template>

<script>
import '@/scss/WeSayHello.scss'

import ClickComponent from '@/components/ClickComponent.vue'
import TodoApp from '@/components/TodoApp.vue'

export default {
  name: 'WeSayHello',
  data () {
    return {
      martin: 'Martin says Hello from variable!',
      joakim: 'Joakim does not say what Martin says, he says something else',
      Sondre: 'Sondre says that Vue is shit cause it hate me, and the syntax is ugly to me :)'
    }
  },

  components: {ClickComponent, TodoApp}
}

</script>


// WEBPACK FOOTER //
// src/views/WeSayHello.vue